export const getDataBySerialNumber = "https://americanboard-us.com/api/OnlineSystem/result/";
export const service_Url="https://americanboard-us.com/api/Services";
export const Company_Url="https://americanboard-us.com/api/Companies";
export const Bublic_Url="https://americanboard-us.com";
export const Contact_Url = "https://americanboard-us.com/api/ContactUs";